<template>
  <div>
    <!-- 头部 -->
    <the-header backPath="/apply/weizhang" v-bind:balance="balance" v-bind:balanceShow="true"></the-header>
    <div class="wlist-ctn">
      <div style="text-align: center;margin-top: 50px" v-if="wList.length == 0">未查询到处理中的违章记录！</div>
      <div class="wlist-item" v-for="v in wList">
        <div class="date">{{v.date}} {{v.wzcity}}</div>
        <div class="act">{{v.act}}</div>
        <div class="info">
          <div>{{v.fen}}分</div>
          <div>{{v.money}}元</div>
          <div v-if="v.handled == 0">未处理</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Cell, Toast } from 'mint-ui';
  import TheHeader from '@/components/TheHeader'

  export default {
    components: {
      [Cell.name]:Cell,
      TheHeader
    },
    data () {
      return {
        balance: null,
        wList: []
      }
    },
    watch: {
    },
    mounted () {
      this.pageInit()
    },
    methods: {
      pageInit() {
        this.fetchData()
      },
      // 下订单并去支付
      fetchData () {
        let params = this.$route.params
        this.$api.goods.getWeizhang(params).then((res) => {
          if (res.data.code == 1) {
            this.wList = res.data.data.lists
          } else {
            Toast(res.data.msg);
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 页面跳转
      goTo (path) {
        this.$router.push(path);
      },
      // 外部跳转
      goToUrl (url) {
        window.location.href = url + '?token=' + localStorage.getItem('token');
      },
      // 开发中
      unopen () {
        Toast("敬请期待...");
      }
    }
  };
</script>

<style lang="scss">
  @import "@/assets/css/my-mint.scss";
  body {
    background-color: #FFFFFF;
  }

  ::-webkit-input-placeholder { /* WebKit browsers */
    color: #666666;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #666666;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #666666;
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #CCCCCC;
  }

  .header-space {
    height: 110px;
  }

  .wlist-ctn {
    .wlist-item {
      padding: 30px 20px;
      border-bottom: 2px solid #ccc;
      .date {
        font-size: 30px;
      }
      .act {
        color: #868686;
        margin: 20px 0;
      }
      .info {
        div {
          display: inline-block;
          background: #00a0e9;
          color: #fff;
          margin-right: 20px;
          padding: 5px 10px;
          font-size: 25px;
        }
      }
    }
  }
  .exchange-content {
    padding: 43px 27px 43px 27px;
    width: 697px;
    overflow: hidden;

    .exchange-title {
      line-height: 54px;
      font-size: 34px;
    }

    .exchange-item-ul {
      padding: 48px 0 33px 0;
      width: 730px;
    }

    .exchange-item-li-box {
      width: 237px;
      float: left;
    }

    .exchange-item-li {
      margin: 0 23px 23px 0;
      width: 214px;
      height: 93px;
      float: left;
      color: #CBA162;
      text-align: center;
      border-radius: 6px;
      border: 1px solid #CBA162;

      .item-title {
        padding: 7px 10px 0 10px;
        height: 48px;
        line-height: 48px;
        font-size: 28px;
        overflow: hidden;
      }

      .item-describe {
        padding: 0 10px 0 10px;
        height: 26px;
        line-height: 26px;
        font-size: 20px;
        overflow: hidden;
      }
    }

    .item-selected {
      background-color: #CBA162;
      color: #FFFFFF;
    }
  }

  .cost-exchange-content {
    padding: 22px 27px 43px 27px;
  }

  .exchange-content-navbar {
    padding: 27px 27px 43px 27px;
  }

  .exchange-form {
    padding: 0 27px 40px 27px;

    .cell-item {
      padding: 0 0 40px;
      height: 90px;

      label {
        padding: 0 20px 0 0;
        font-size: 26px;
      }
    }

    .input-item {
      margin: 0;
      padding: 0 35px 0 35px;
      border: 0;
      border-radius: 6px;
      width: 626px;
      height: 90px;
      line-height: 90px;
      font-size: 26px;
      background-color: #F0F0F0;
    }

    .contents-note {
      padding: 10px 6px 0 6px;
      line-height: 38px;
      font-size: 20px;
      color: #4A4A4A;

      .note-title {
        line-height: 40px;
        font-size: 22px;
      }
    }
  }

  .exchange-form-navbar {
    padding: 43px 27px 0 27px;

    .cell-item {
      padding: 0 0 0;
    }
  }

  .wx-navbar {
    width: 100%;
    height: 124px;
    border-bottom: 1px solid #979797;

    .wx-navbar-item {
      position: relative;
      width: 50%;
      height: 124px;
      line-height: 124px;
      font-size: 32px;
      text-align: center;
      float: left;

      .item-title-left {
        padding-left: 10%;
      }

      .item-title-right {
        padding-right: 10%;
      }
    }

    .wx-navbar-item-active {
      color: #CBA162;
    }

    .active-line {
      position: absolute;
      bottom:0;
      left:50%;
      transform:translateX(-50%) translateY(1px);
      width: 128px;
      height: 8px;
      background-color: #CBA162;
    }
  }

  .wx-action-sheet {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    color: #000000;
    background-color: #FFFFFF;
    z-index: 150;

    .wx-action-sheet-bg-skin {
      position: fixed;
      top: 0;
      left: 0;
      width: 750px;
      height: 100%;
      background-color: #000000;
      filter:alpha(Opacity=80);
      -moz-opacity:0.8;
      opacity: 0.8;
      z-index: 100;
    }

    .wx-action-sheet-box {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 750px;
      background-color: #FFFFFF;
      overflow-x: hidden;
      overflow-y: auto;
      z-index: 150;
    }

    .action-title {
      position: relative;
      width: 750px;
      height: 105px;
      line-height: 105px;
      font-size: 34px;
      font-weight: bold;
      text-align: center;

      .action-close {
        position: absolute;
        top: 26px;
        left: 26px;
        width: 60px;
        height: 60px;
        background-image: url('~@/assets/images/img-close.png');
        background-size: 30px 30px;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .content-title {
      padding: 8px 0 0 0;
      width: 750px;
      height: 92px;
      line-height: 92px;
      font-size: 36px;
      font-weight: bold;
      text-align: center;
      border-top: 1px solid #E5E5E5;
    }

    .content-item {
      position: relative;
      padding: 0 33px 0 33px;
      width: 684px;
      height: 100px;
      line-height: 100px;
      font-size: 26px;
      text-align: left;
      border-top: 1px solid #E5E5E5;

      .item-label {
        width: 750px;
        height: 100px;
        line-height: 100px;
      }

      .item-value {
        position: absolute;
        top: 0;
        right: 33px;
        height: 100px;
        line-height: 100px;
        color: #4A4A4A;
      }

      .item-value-arrows {
        padding: 0 40px 0 0;
        background-image: url('~@/assets/images/img-right-arrows.png');
        background-size: 20px 32px;
        background-repeat: no-repeat;
        background-position: center right;
      }
    }

    .action-confirm {
      padding: 52px 20px 20px 20px;
      height: 134px;
      border-top: 1px solid #D2D3D5;
    }

    .action-confirm-button {
      width: 710px;
      height: 94px;
      line-height: 94px;
      font-size: 34px;
      color: #FFFFFF;
      text-align: center;
      border-radius: 8px;
      background-color: #000000;
    }

    .action-confirm-button-disabled {
      background-color: #BFBFBF;
    }
  }

  .wx-bottom-operate-space {
    height: 107px;
  }

  .wx-bottom-operate {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 107px;
    background-color: #FFFFFF;

    .operate-box {
      width: 375px;
      height: 106px;
      float: left;
      text-align: center;
    }

    .operate-info {
      float: left;
      border-top: 1px solid #979797;

      .operate-title {
        padding: 13px 0 0 0;
        line-height: 52px;
        font-size: 32px;
      }

      .operate-describe {
        line-height: 28px;
        font-size: 20px;
        color: #4A4A4A;
      }
    }

    .operate-button {
      line-height: 106px;
      font-size: 32px;
      float: right;
      color: #FFFFFF;
      background-color: #000000;
      border-top: 1px solid #000000;
    }

    .operate-button-disabled {
      background-color: #BFBFBF;
      border-top: 1px solid #BFBFBF;
    }
  }
</style>
